import { z } from "zod"

export const pvWattsV8SscInfoSchema = z.object({
  version: z.number(),
  build: z.string(),
  module: z.string(),
})

export type PvWattsV8SscInfo = z.infer<typeof pvWattsV8SscInfoSchema>
